import React, {Component} from "react";
import { Link } from 'react-router-dom';

import defaultAvatar from '../../images/default-avatar.jpg'

export default (props) => {

    const {
        isAdmin,
        item,
        setUserStatus,
        deleteEmployee,
        handleEdit,
        showTransaction,
        currentUser,
    } = props;

    return(
            <li className="worker">
                <div className="avatar">
                    {
                        item.user.avatar
                        ? <div className="img" style={{backgroundImage: `url(${item.user.avatar})`}}></div>
                        : <div className="img" style={{backgroundImage: `url(${defaultAvatar})`}}></div>
                    }
                </div>
                <div className="worker-right">
                    <div className="info">
                        <div className="worker-person">
                            <div style={{flexGrow:1}}>
                                <Link to={`/profile/${item.user.id}`}>
                                    <strong className="name">{`${item.user.first_name} ${item.user.last_name}`}</strong>
                                </Link>
                                {
                                    item.is_admin ?
                                    <span className="user-tag">admin</span>
                                    : null
                                }
                            </div>                                                        
                                <div className="actions-del-edit">
                                {
                                    isAdmin.length ?
                                    <div
                                        onClick={() => handleEdit(item)}
                                        className="action-edit"
                                        >
                                    </div>
                                    : null
                                }
                                    
                                {
                                    isAdmin.length && !item.is_admin ?
                                    <div
                                        className="action-delete"
                                        onClick={() => deleteEmployee(item)}
                                        >
                                    </div>
                                    : null
                                }
                                </div>
                        </div>
                        <span className="email">{item.user.email}</span>
                        <div className="detail-row">
                            <span className="limit">Лимит: <span className="text_pink_d">{item.balance_limit} р.</span></span>
                            {
                                isAdmin.length || item.user.id === currentUser.id ?
                                <span className="small-button detail-transaction">
                                    <button
                                        onClick={() => showTransaction(item)}
                                        >
                                        Детализация затрат
                                    </button>
                                </span>
                                : null
                            }
                        </div>
                        
                    </div>

                    {
                        isAdmin.length && true !== item.is_admin
                        ?
                        <div
                            onClick={() => setUserStatus(item)}
                            className={!item.is_blocked ? "worker-status-slider yes" : "worker-status-slider no"}
                            title={!item.is_blocked ? "Блокировать" : "Разблокировать"}
                            >
                            <div className="radio"></div>
                        </div>
                        :
                        null
                    }
                </div>
            </li>
        )
}


// WEBPACK FOOTER //
// ./src/components/AccountLaw/StaffListItem.js